import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTimeFlies: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTimeFlies"><Path fillRule="evenodd" clipRule="evenodd" d="M7 12C7 7.58172 10.5817 4 15 4C19.4183 4 23 7.58172 23 12C23 16.4183 19.4183 20 15 20C10.5817 20 7 16.4183 7 12ZM2 7H6V8.5H2V7ZM15.75 8V11.6893L18.0607 14L17 15.0607L14.25 12.3107V8H15.75ZM1 11.25H5V12.75H1V11.25ZM2 15.5H6V17H2V15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTimeFlies;
